import  { useState , useEffect } from 'react'
import moment from 'moment';

import './ElapsedTime.style.scss';

interface IElapsedTimeProps {
    startDate: Date;
    endDate?: Date | null;
}

const MILLISECONDS_PER_HOUR = 1000 * 60 * 60 * 24;
export const ElapsedTime = ({startDate, endDate}:IElapsedTimeProps) => {

    const [elapsedDate,setElapsedDate] = useState<Date | null>(null);
    const setElpased = () => setElapsedDate(new Date((endDate ? endDate.getTime() : new Date().getTime()) - startDate.getTime()));
    const getNumberOfDays = (fromDate: Date) => {
        if (!fromDate || fromDate.getTime() < MILLISECONDS_PER_HOUR) {
            return '';
        }
        return Math.floor(fromDate.getTime() / MILLISECONDS_PER_HOUR) + 'j ';
    }
 
    useEffect(() => {
        setElpased();
    }, []);

    useEffect(() => {
        if(endDate) {
            return;
        }
        const timer = window.setInterval(()=> setElpased(), 1000);
        return () => {
            clearInterval(timer);
        }
    }, [elapsedDate]);

    return(
        <span className={`elapsed-time-span ${endDate ? 'finished' : 'running'}`}>{elapsedDate ? moment.utc(elapsedDate).format(getNumberOfDays(elapsedDate) + 'HH:mm:ss') : 'N/A'}</span>
    )
}

export default ElapsedTime;